import React from 'react';
import { TableCourseProps } from './types';
import { TableContainer, TableHeader, TableBody, TableRow } from './styled';

export const TableCourse = ({
  headers,
  columnWidths,
  alignments,
  styleTable,
  styleHeader,
  styleBody,
  styleRow,
  colorScroll,
  scrollActiveAt,
  data,
  excludedColumns,
  expanded = false,
  renderActions
}: TableCourseProps) => (
  <TableContainer
    data-testid="cmp-table-course"
    style={styleTable}
    colorScroll={colorScroll}
    scrollActiveAt={scrollActiveAt}
  >
    <TableHeader
      columns={columnWidths}
      alignments={alignments}
      scrollActiveAt={scrollActiveAt}
      style={styleHeader}
    >
      {headers.map((header, index) => (
        <div
          key={`${header}-${index}`}
          style={{
            textAlign:
              (alignments[index] as React.CSSProperties['textAlign']) ??
              'center'
          }}
        >
          {header}
        </div>
      ))}
    </TableHeader>
    <TableBody expanded={expanded} style={styleBody}>
      {data.map((row, rowIndex) => (
        <TableRow
          key={row?.id || rowIndex}
          data-testid="table-row"
          columns={columnWidths}
          scrollActiveAt={scrollActiveAt}
          style={styleRow}
          className={row?.isDisabled ? 'disabled' : ''}
        >
          {Object.values(row)
            ?.filter(
              (_, index) =>
                !excludedColumns?.includes(Object.keys(data[0])[index])
            )
            ?.map((value, colIndex) => (
              <div
                key={`${Object.keys(row)[colIndex]}-${rowIndex}`}
                style={{
                  textAlign:
                    (alignments[
                      colIndex
                    ] as React.CSSProperties['textAlign']) ?? 'center'
                }}
              >
                {value}
              </div>
            ))}
          {renderActions && (
            <div
              style={{
                textAlign:
                  (alignments[
                    alignments.length - 1
                  ] as React.CSSProperties['textAlign']) ?? 'center'
              }}
            >
              {renderActions(row)}
            </div>
          )}
        </TableRow>
      ))}
    </TableBody>
  </TableContainer>
);
